// extracted by mini-css-extract-plugin
export default {"main":"Supporting_main__TX1OC","h1":"Supporting_h1__lUe3b","span":"Supporting_span__-B3e2","h11":"Supporting_h11__KymkI"};